import { gql } from '~/techstyle-shared/react-graphql';

// Reference: https://studio.apollographql.com/graph/fashionos/variant/dev/schema/reference/objects/ProductListResult?query=productlisting
// Previous version: {BASE_PRODUCTS_RELATED_PRODUCTS_QUERY} from '~/techstyle-shared/react-graphql/queries/products';

// TODO: remove unnecessary fields
const RELATED_PRODUCTS_QUERY = gql`
  fragment SwatchFields on Swatch {
    isSelf
    label
    url
    productId
  }

  fragment ImageFields on ProductImage {
    angle
    sizes {
      height
      width
      url
    }
  }

  fragment RelatedProductsFields on RelatedProductObject {
    color
    dateExpected
    isAvailable
    isSelf
    itemNumber
    permalink
    masterProductId
    isWarehouseProduct
    tags {
      id
    }
    images {
      default {
        ...ImageFields
      }
      plus {
        ...ImageFields
      }
    }
  }

  fragment ComponentProductIdObjectFields on ComponentProductIdObject {
    color
    componentProductId
    groupCode
    isSelf
    priceContributionPercentage
    __typename
  }

  query GridRelatedProducts(
    $productQuery: ProductQuery
    $size: Int
    $sort: Sort
    $from: Int
    $shouldShowWarehouseProducts: Boolean
    $excludeTagIds: [Int!]
  ) {
    productListing(
      from: $from
      productQuery: $productQuery
      size: $size
      sort: $sort
    ) {
      products {
        label
        masterProductId
        productTypeId
        relatedProducts(
          limit: 6
          filter: {
            isWarehouseProduct: $shouldShowWarehouseProducts
            excludeTagIds: $excludeTagIds
          }
        ) {
          ...RelatedProductsFields
        }
        swatches {
          ...SwatchFields
        }
        # TODO: update gql schema to return field as componentProductIdObjectList instead of componentProductIdObject
        componentProductIdObjectList: componentProductIdObject {
          ...ComponentProductIdObjectFields
        }
        defaultProductCategory {
          label
        }
      }
    }
  }
`;

/**
 * Function to fetch related product data using GraphQL via Apollo client.
 *
 * @param {Object} apolloClient - Apollo client instance
 * @param {Array} masterProductIds - Array of master product IDs
 * @param {boolean} shouldShowWarehouseProducts - Flag to indicate if warehouse products should be shown
 * @returns {Promise} - Promise that resolves to the related product data
 */
const getGqlRelatedProductData = ({
  apolloClient,
  masterProductIds,
  shouldShowWarehouseProducts = false,
}) => {
  const relatedProductsVariables = {
    productQuery: {
      masterProductId: {
        in: masterProductIds.map((id) => Number(id)),
      },
    },
    shouldShowWarehouseProducts,
  };

  return apolloClient.query({
    context: { clientName: 'supergraph' },
    query: RELATED_PRODUCTS_QUERY,
    variables: relatedProductsVariables,
  });
};

export default getGqlRelatedProductData;
